import { useCallback, useState } from 'react';
import useAnalyticsContext from '|/hooks/use-analytics-context';

const generateGuid = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export const usePlaidEventTracking = () => {
  const [correlationId] = useState(generateGuid());

  const { trackEvent } = useAnalyticsContext();

  const trackPlaidEvent = useCallback(
    (eventType: string, eventData?: object) => {
      trackEvent('PAO Modal Plaid Flow', {
        ...eventData,
        eventType,
        step: 'complete_purchase_pao',
        correlationId,
        timestamp: new Date().toISOString()
      });
    },
    [trackEvent, correlationId]
  );

  return { trackPlaidEvent };
};
